// עורך רשימת קישורים (תווית + URL).
export interface LinkItem { label: string; url: string }

export function LinksEditor({ value, onChange, legend = 'קישורים' }: { value: LinkItem[]; onChange: (v: LinkItem[]) => void; legend?: string }) {
  const set = (i: number, patch: Partial<LinkItem>) => onChange(value.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  return (
    <fieldset className="box">
      <legend>{legend}</legend>
      <div className="stack">
        {value.map((l, i) => {
          const bad = l.url !== '' && !isUrl(l.url);
          return (
            <div className="row" key={i}>
              <input aria-label={`תווית קישור ${i + 1}`} placeholder="תווית" value={l.label} onChange={(e) => set(i, { label: e.target.value })} style={{ flex: '1 1 120px' }} />
              <input aria-label={`כתובת קישור ${i + 1}`} aria-invalid={bad} className="ltr" placeholder="https://" value={l.url} onChange={(e) => set(i, { url: e.target.value })} style={{ flex: '2 1 200px', borderColor: bad ? 'var(--danger)' : undefined }} />
              <button type="button" className="btn small danger" onClick={() => onChange(value.filter((_, j) => j !== i))} aria-label={`הסרת קישור ${i + 1}`}>הסרה</button>
            </div>
          );
        })}
        {value.some((l) => l.url && !isUrl(l.url)) && <div className="small" style={{ color: 'var(--danger)' }}>כתובת לא תקינה — נדרש URL מלא כולל https://</div>}
        <div><button type="button" className="btn small" onClick={() => onChange([...value, { label: '', url: '' }])}>הוספת קישור</button></div>
      </div>
    </fieldset>
  );
}

export function isUrl(s: string) { try { const u = new URL(s); return u.protocol === 'http:' || u.protocol === 'https:'; } catch { return false; } }
